import { Card, Divider, Typography } from "antd";
import BinBulkScan from "../../../ManageBin/Bin/BinBulkScan";
import "../../../../styles/global-ui.css";

const BinBulkScanPage = ({ userData }) => {
  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
            Dispatch Center Bulk Bin Scan
          </Typography.Title>
          <Typography.Text className="page-subtitle">
            Scan or enter a bin ID to add it to bulk outward
          </Typography.Text>
        </div>
      </div>

      <Divider className="page-divider" />

      <Card className="modern-card">
        <BinBulkScan userData={userData} />
      </Card>
    </div>
  );
};

export default BinBulkScanPage;